
import { formatPriceRP } from "@/app/infrastructures/misc/Utils";
import { prop, Vue } from "vue-class-component";

class Props {
  showPopupDetailProduct = prop<boolean>({
    default: false,
    type: Boolean
  });
  onClosePopup = prop<Function>({
    required: true
  });
  data = prop<any>({
    required: true
  });
}
class ModalDetailProductKulioner extends Vue.with(Props) {
  get sumQuantity() {
    return this.data.reduce((sum: any, item: any) => sum + item.kodQuantity, 0);
  }
  formatPrice(val: any) {
    return formatPriceRP(val);
  }
}
export default ModalDetailProductKulioner;
